import React, { FC, forwardRef, ForwardRefRenderFunction, MouseEventHandler, useEffect, useImperativeHandle, useRef } from 'react';
import { useState } from 'react';
import styles from './styles.scss';
import cls from '@utils/css-select';

const cx = cls(styles);
type TabProps = {
	tabs: {
		title: string;
		content: string;
	}[];
	activeIndex?: number;
	children?: React.ReactNode[];
	onChange?: (index: number) => void;
	prefix?: string;
};

const Tab: ForwardRefRenderFunction<unknown, TabProps> = (props, ref) => {
	const { prefix = `ac`, tabs } = props;
	const [value, setValue] = useState(0);
	const classnames = (str: string, rest?: any) => cx(`${prefix}-${str}`, ...[rest || []]);
	const barRef = useRef<HTMLDivElement>(null);
	const contentRef = useRef<HTMLDivElement>(null);
	const tablistRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (contentRef.current && tabs.length > 1) {
			const selectEle = document.querySelector('.ac-tab.selected');
			const clientWidth = selectEle?.clientWidth || 100;
			const offsetLeft = selectEle?.offsetLeft || 0;
			if (barRef.current) {
				barRef.current.style.width = `${clientWidth}px`;
				barRef.current.style.left = `${offsetLeft}px`;
			}
		}
	}, [contentRef.current, barRef.current, value]);

	useImperativeHandle(ref, () => {
		return {
			tabList: tablistRef.current,
		};
	});

	return (
		<div className={classnames('tabs')} ref={tablistRef}>
			{tabs.length > 1 ? (
				<div className={classnames('tablist')} ref={contentRef}>
					{tabs.map((item, index) => {
						return item.title ? (
							<div
								key={index}
								className={classnames('tab', { selected: value === index })}
								onClick={(e: any) => {
									setValue(index);
								}}>
								{item.title}
							</div>
						) : null;
					})}
					<div className={classnames('tab-bar')} ref={barRef}></div>
				</div>
			) : null}
			<div className={'tabcontent'}>{props?.children?.[value]}</div>
		</div>
	);
};

export default forwardRef(Tab);
